import { store } from '../../store'

export const editCourse = async ( id: number, course: any ) => {

    let response

    try {

        response = await fetch( `${ process.env.REACT_APP_API_ORIGIN }/1.0.0/cms/courses/${ id }`, {
            body: JSON.stringify( course ),
            headers: {
                'Authorization': 'Bearer ' + store.getState().session.token,
                'Content-Type': 'application/json'
            },
            method: 'POST'
        } )

    } catch ( exception ) {

        store.dispatch( { type: 'EDIT_COURSE_TIMEOUT' } )
        return

    }

    if ( response.status === 401 ) {

        store.dispatch( { type: 'EDIT_COURSE_UNAUTHORIZED' } )
        return

    }

    if ( response.status !== 200 ) {

        store.dispatch( { type: 'EDIT_COURSE_UNEXPECTEDRESPONSE' } )
        return

    }

    store.dispatch( { type: 'EDIT_COURSE_OK' } )

}